/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Odesláno`
};

const da_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Sendt`
};

const de_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Geliefert`
};

const en_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Shipped`
};

const es_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Enviado`
};

const fr_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Livré`
};

const hu_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Szállítva`
};

const it_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Consegnato`
};

const nl_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Verzonden`
};

const pl_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Wysłano`
};

const pt_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Enviado`
};

const sv_shipped = /** @type {(inputs: {}) => string} */ () => {
	return `Levererad`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const shipped = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.shipped(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("shipped", locale)
	if (locale === "cs") return cs_shipped(inputs)
	if (locale === "da") return da_shipped(inputs)
	if (locale === "de") return de_shipped(inputs)
	if (locale === "en") return en_shipped(inputs)
	if (locale === "es") return es_shipped(inputs)
	if (locale === "fr") return fr_shipped(inputs)
	if (locale === "hu") return hu_shipped(inputs)
	if (locale === "it") return it_shipped(inputs)
	if (locale === "nl") return nl_shipped(inputs)
	if (locale === "pl") return pl_shipped(inputs)
	if (locale === "pt") return pt_shipped(inputs)
	return sv_shipped(inputs)
};